export default __webpack_public_path__ + "static/media/ic_svc_tv_plus.fd97828f.png";